export default "__VITE_ASSET__DumVRo3r__"